<template>
    <div>
        <div class="row">
            <!-- Breadcrumb -->
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'integraciones' }">{{ $t("integraciones") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'businesscentral' }">{{ $t("businessCentral") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("bajaEntidades") }}</li>
                    </ol>
                </nav>
            </div>
        </div>

        <!-- Cabecera: Card con botón global y contadores -->
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-12">
                <div class="card" style="padding: 16px;">
                    <div class="d-flex align-items-center" style="gap: 12px; flex-wrap: wrap;">
                        <button class="btn btn-primary btn-outline-secondary" @click="getAllDowngrades" :disabled="loadingAll">
                            <i class="fas fa-search"></i> {{ $t('consultarTodo') }}
                        </button>
                        <div class="ml-auto d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;">
                            <span class="badge badge-info">{{ $t('bajaProductos') }}: {{ (downgradesProducts && downgradesProducts.totalDowngrades) || 0 }}</span>
                            <span class="badge badge-info">{{ $t('bajaSubproductos') }}: {{ (downgradesSubproducts && downgradesSubproducts.totalDowngrades) || 0 }}</span>
                            <span class="badge badge-info">{{ $t('bajaUdMedida') }}: {{ unitsTotal }}</span>
                            <span class="badge badge-info">{{ $t('bajaLineaProd') }}: {{ (downgradesLines && downgradesLines.length) || 0 }}</span>
                            <span class="badge badge-info">{{ $t('bajaFormaPago') }}: {{ (downgradedPaymentMethods.total) || 0 }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabs con acordeón por sección -->
        <el-tabs v-model="activeTab">
            <!-- Productos -->
            <el-tab-pane :label="$t('bajaProductos') + (downgradesProducts && downgradesProducts.totalDowngrades ? ' ('+downgradesProducts.totalDowngrades+')' : '')" name="products">
                <div class="card" style="padding-left: 20px;">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="card-text"><p>{{ $t('bajaProductos') }}</p></div>
                        <div class="d-flex" style="gap: 8px;">
                            <button class="btn btn-primary btn-sm" @click="getProductsDowngrades({ openModal: false })">
                                <i class="fas fa-search"></i> {{ $t('consultar') }}
                            </button>
                            <button class="btn btn-outline-secondary btn-sm"
                                :disabled="!(downgradesProducts && downgradesProducts.downgrades && downgradesProducts.downgrades.length)"
                                @click="openProductsDowngradesModal()">
                                <i class="fas fa-eye"></i> {{ $t('detalles') }}
                            </button>
                        </div>
                    </div>
                    <el-collapse v-model="collapseActive.products" class="mt-2">
                        <el-collapse-item name="panel">
                            <template slot="title">{{ $t('desplegar') }}</template>
                            <template v-if="!isLoadingAny">
                                <div v-if="downgradesProducts && downgradesProducts.downgrades && downgradesProducts.downgrades.length > 0" class="table-responsive">
                                    <table class="table table-bordered table-hover table-striped">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>{{ $t('producto') }}</th>
                                                <th>ID</th>
                                                <th>{{ $t('affectedRecipes') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(product, index) in downgradesProducts.downgrades" :key="'P-' + index">
                                                <td>{{ product.productName || $t('unknownProduct') }}</td>
                                                <td>{{ product.numierId || '-' }}</td>
                                                <td>
                                                    <template v-if="product.affectedRecipes && product.affectedRecipes.length">
                                                        {{ product.affectedRecipes.length }}
                                                    </template>
                                                    <template v-else>0</template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-success text-center">{{ $t('noHayBajasQueMostrar') }}</div>
                            </template>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-tab-pane>

            <!-- Subproductos -->
            <el-tab-pane :label="$t('bajaSubproductos') + (downgradesSubproducts && downgradesSubproducts.totalDowngrades ? ' ('+downgradesSubproducts.totalDowngrades+')' : '')" name="subproducts">
                <div class="card" style="padding-left: 20px;">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="card-text"><p>{{ $t('bajaSubproductos') }}</p></div>
                        <div class="d-flex" style="gap: 8px;">
                            <button class="btn btn-primary btn-sm" @click="getSubproductsDowngrades({ openModal: false })">
                                <i class="fas fa-search"></i> {{ $t('consultar') }}
                            </button>
                            <button class="btn btn-outline-secondary btn-sm"
                                :disabled="!(downgradesSubproducts && downgradesSubproducts.downgrades && downgradesSubproducts.downgrades.length)"
                                @click="openSubproductsDowngradesModal()">
                                <i class="fas fa-eye"></i> {{ $t('detalles') }}
                            </button>
                        </div>
                    </div>
                    <el-collapse v-model="collapseActive.subproducts" class="mt-2">
                        <el-collapse-item name="panel">
                            <template slot="title">{{ $t('desplegar') }}</template>
                            <template v-if="!isLoadingAny">
                                <div v-if="downgradesSubproducts && downgradesSubproducts.downgrades && downgradesSubproducts.downgrades.length > 0" class="table-responsive">
                                    <table class="table table-bordered table-hover table-striped">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>{{ $t('subproducto') }}</th>
                                                <th>ID</th>
                                                <th>{{ $t('affectedRecipes') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(sub, index) in downgradesSubproducts.downgrades" :key="'S-' + index">
                                                <td>{{ sub.subProductName || $t('unknownProduct') }}</td>
                                                <td>{{ sub.numierId || '-' }}</td>
                                                <td>
                                                    <template v-if="sub.affectedRecipes && sub.affectedRecipes.length">
                                                        {{ sub.affectedRecipes.length }}
                                                    </template>
                                                    <template v-else>0</template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-success text-center">{{ $t('noHayBajasQueMostrar') }}</div>
                            </template>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-tab-pane>

            <!-- Unidades -->
            <el-tab-pane :label="$t('bajaUdMedida') + (unitsTotal ? ' ('+unitsTotal+')' : '')" name="units">
                <div class="card" style="padding-left: 20px;">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="card-text"><p>{{ $t('bajaUdMedida') }}</p></div>
                        <div class="d-flex" style="gap: 8px;">
                            <button class="btn btn-primary btn-sm" @click="getProductsDowngradesUnits({ openModal: false })">
                                <i class="fas fa-search"></i> {{ $t('consultar') }}
                            </button>
                            <button class="btn btn-outline-secondary btn-sm"
                                :disabled="!unitsTotal"
                                @click="openProductsDowngradesUnitsModal()">
                                <i class="fas fa-eye"></i> {{ $t('detalles') }}
                            </button>
                        </div>
                    </div>
                    <el-collapse v-model="collapseActive.units" class="mt-2">
                        <el-collapse-item name="panel">
                            <template slot="title">{{ $t('desplegar') }}</template>
                            <template v-if="!isLoadingAny">
                                <div v-if="unitsTotal" class="table-responsive">
                                    <table class="table table-bordered table-hover table-striped">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>{{ $t('bajaUdMedida') }}</th>
                                                <th>{{ $t('totalDowngrades') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ $t('unidades') }}</td>
                                                <td>{{ unitsTotal }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-success text-center">{{ $t('noHayBajasQueMostrar') }}</div>
                            </template>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-tab-pane>

            <!-- Líneas -->
            <el-tab-pane :label="$t('bajaLineaProd') + (downgradesLines && downgradesLines.length ? ' ('+downgradesLines.length+')' : '')" name="lines">
                <div class="card" style="padding-left: 20px;">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="card-text"><p>{{ $t('bajaLineaProd') }}</p></div>
                        <div class="d-flex" style="gap: 8px;">
                            <button class="btn btn-primary btn-sm" @click="getProductsDowngradesLines({ openModal: false })">
                                <i class="fas fa-search"></i> {{ $t('consultar') }}
                            </button>
                            <button class="btn btn-outline-secondary btn-sm"
                                :disabled="!(downgradesLines && downgradesLines.length)"
                                @click="openProductsDowngradesLinesModal()">
                                <i class="fas fa-eye"></i> {{ $t('detalles') }}
                            </button>
                        </div>
                    </div>
                    <el-collapse v-model="collapseActive.lines" class="mt-2">
                        <el-collapse-item name="panel">
                            <template slot="title">{{ $t('desplegar') }}</template>
                            <template v-if="!isLoadingAny">
                                <div v-if="downgradesError" class="alert alert-danger">
                                    <i class="fas fa-exclamation-triangle"></i> {{ downgradesError }}
                                </div>
                                <div v-else-if="downgradesLines && downgradesLines.length" class="table-responsive">
                                    <table class="table table-bordered table-hover table-striped">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>#</th>
                                                <th>{{ $t('producto') }}</th>
                                                <th>{{ $t('subproducto') }}</th>
                                                <th>{{ $t('mensaje') }}</th>
                                                <th>{{ $t('estado') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(line, index) in downgradesLines" :key="'L-' + index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ line.idProduct }}</td>
                                                <td>{{ line.idSubproduct }}</td>
                                                <td>{{ line.message }}</td>
                                                <td>
                                                    <span :class="['badge', line.deleted ? 'badge-success' : 'badge-warning']">
                                                        {{ line.deleted ? $t('eliminado') : $t('pendiente') }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-success text-center">{{ $t('noHayBajasQueMostrar') }}</div>
                            </template>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-tab-pane>

            <!-- Formas de pago -->
            <el-tab-pane :label="$t('bajaFormaPago') + (downgradedPaymentMethods && downgradedPaymentMethods.procesados ? ' ('+downgradedPaymentMethods.total +')' : '')" name="paymentMethods">
                <div class="card" style="padding-left: 20px;">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="card-text"><p>{{ $t('bajaFormaPago') }}</p></div>
                        <div class="d-flex" style="gap: 8px;">
                            <button class="btn btn-primary btn-sm" @click="getPaymentMethodsDowngrades({ openModal: false })">
                                <i class="fas fa-search"></i> {{ $t('consultar') }}
                            </button>
                            <button class="btn btn-outline-secondary btn-sm"
                                :disabled="!(downgradedPaymentMethods && downgradedPaymentMethods.total)"
                                @click="openPaymentMethodsDowngradesModal()">
                                <i class="fas fa-eye"></i> {{ $t('detalles') }}
                            </button>
                        </div>
                    </div>
                    <el-collapse v-model="collapseActive.lines" class="mt-2">
                        <el-collapse-item name="panel">
                            <template slot="title">{{ $t('desplegar') }}</template>
                            <template v-if="!isLoadingAny">
                                <div v-if="downgradesError" class="alert alert-danger">
                                    <i class="fas fa-exclamation-triangle"></i> {{ downgradesError }}
                                </div>
                                <div v-else-if="downgradedPaymentMethods.procesados && downgradedPaymentMethods.total" class="table-responsive">
                                    <table class="table table-bordered table-hover table-striped">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>#</th>
                                                <th>{{ $t('formaDePago') }}</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(method, index) in downgradedPaymentMethods.procesados" :key="'L-' + index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ method.nombre }}</td>
                                               
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-success text-center">{{ $t('noHayBajasQueMostrar') }}</div>
                            </template>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-tab-pane>
        </el-tabs>

        <!-- Modal Bajas de Materias primas -->
        <modal name="modal-downgrades-subproducts" :adaptive="true" :scrollable="true" height="auto"
            :clickToClose="true">
            <div>
                <!-- Header -->
                <div class="modal-header wrapperTitle">
                    <h4 style="margin: 0px">{{ $t('subproductDowngrades') }}</h4>
                    <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
                </div>

                <!-- Body -->
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- Totales -->
                            <div class="form-group" v-if="downgradesSubproducts">
                                <label>{{ $t("summary") }}</label>
                                <p>
                                    <strong>{{ $t("totalDowngrades") }}:</strong> {{
                                        downgradesSubproducts.totalDowngrades }}<br>
                                    <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{
                                        downgradesSubproducts.totalAffectedRecipes
                                    }}
                                </p>
                            </div>
                        </div>

                        <!-- Lista de subproducts dados de baja -->
                        <div class="col-md-12"
                            v-if="downgradesSubproducts && downgradesSubproducts.downgrades && downgradesSubproducts.downgrades.length > 0">
                            <div class="form-group">
                                <label>{{ $t("downgradedProducts") }}</label>
                                <ul class="list-group">
                                    <li v-for="(subproduct, index) in downgradesSubproducts.downgrades"
                                        :key="'DOWN-' + subproduct.numierId" class="list-group-item">
                                        <strong>#{{ index + 1 }} {{ subproduct.subProductName || $t("unknownProduct")
                                        }}</strong>
                                        <!-- <span class="text-muted"> (ID: {{ subproduct.numierId }})</span> -->

                                        <!-- Recetas afectadas -->
                                        <div v-if="subproduct.affectedRecipes && subproduct.affectedRecipes.length > 0"
                                            class="mt-2">
                                            <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                                            <ul class="pl-3">
                                                <li v-for="recipe in subproduct.affectedRecipes"
                                                    :key="'REC-' + recipe.recipeId" class="flex items-center gap-2">
                                                    <i class="fa fa-cutlery"></i>
                                                    {{ recipe.name }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else class="text-muted">
                                            {{ $t("noRecipesAffected") }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="closeSubproductsDowngradesModal" class="btn btn-secondary">
                            <i class="fas fa-times"></i> {{ $t("cerrar") }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- Modal Bajas de Productos -->
        <modal name="modal-downgrades-products" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header wrapperTitle">
                    <h4 style="margin: 0px">{{ $t('productDowngrades') }}</h4>
                    <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
                </div>

                <!-- Body -->
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- Totales -->
                            <div class="form-group" v-if="downgradesProducts">
                                <label>{{ $t("summary") }}</label>
                                <p>
                                    <strong>{{ $t("totalDowngrades") }}:</strong> {{ downgradesProducts.totalDowngrades
                                    }}<br>
                                    <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{
                                        downgradesProducts.totalAffectedRecipes }}
                                </p>
                            </div>
                        </div>

                        <!-- Lista de productos dados de baja -->
                        <div class="col-md-12"
                            v-if="downgradesProducts && downgradesProducts.downgrades && downgradesProducts.downgrades.length > 0">
                            <div class="form-group">
                                <label>{{ $t("downgradedProducts") }}</label>
                                <ul class="list-group">
                                    <li v-for="(product, index) in downgradesProducts.downgrades"
                                        :key="'DOWN-' + product.numierId" class="list-group-item">
                                        <strong>#{{ index + 1 }} {{ product.productName || $t("unknownProduct")
                                        }}</strong>
                                        <!-- <span class="text-muted"> (ID: {{ product.numierId }})</span> -->

                                        <!-- Recetas afectadas -->
                                        <div v-if="product.affectedRecipes && product.affectedRecipes.length > 0"
                                            class="mt-2">
                                            <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                                            <ul class="pl-3">
                                                <li v-for="recipe in product.affectedRecipes"
                                                    :key="'REC-' + recipe.recipeId" class="flex items-center gap-2">
                                                    <i class="fa fa-cutlery"></i>
                                                    {{ recipe.name }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else class="text-muted">
                                            {{ $t("noRecipesAffected") }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="closeProductsDowngradesModal" class="btn btn-secondary">
                            <i class="fas fa-times"></i> {{ $t("cerrar") }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- Modal Bajas de Unidades -->
        <modal name="modal-downgrades-units" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header wrapperTitle">
                    <h4 style="margin: 0px">{{ $t('unidadesMedidaDadasDeBaja') }}</h4>
                    <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
                </div>

                <!-- Body -->
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- Totales -->
                            <div class="form-group" v-if="downgradesUnits">
                                <label>{{ $t("summary") }}</label>
                                <p>
                                    <strong>{{ $t("totalDowngrades") }}:</strong> {{ unitsTotal }}<br>
                                    <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{ unitsTotal }}
                                </p>
                            </div>
                        </div>

                        <!-- Lista de productos dados de baja -->
                        <div class="col-md-12"
                            v-if="downgradesUnits && downgradesUnits.downgrades && downgradesUnits.downgrades.length > 0">
                            <div class="form-group">
                                <label>{{ $t("downgradedProducts") }}</label>
                                <ul class="list-group">
                                    <li v-for="(product, index) in downgradesUnits.downgrades"
                                        :key="'DOWN-' + product.numierId" class="list-group-item">
                                        <strong>#{{ index + 1 }} {{ product.productName || $t("unknownProduct")
                                        }}</strong>
                                        <!-- <span class="text-muted"> (ID: {{ product.numierId }})</span> -->

                                        <!-- Recetas afectadas -->
                                        <div v-if="product.affectedRecipes && product.affectedRecipes.length > 0"
                                            class="mt-2">
                                            <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                                            <ul class="pl-3">
                                                <li v-for="recipe in product.affectedRecipes"
                                                    :key="'REC-' + recipe.recipeId" class="flex items-center gap-2">
                                                    <i class="fa fa-cutlery"></i>
                                                    {{ recipe.name }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else class="text-muted">
                                            {{ $t("noRecipesAffected") }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="closeProductsDowngradesUnitsModal" class="btn btn-secondary">
                            <i class="fas fa-times"></i> {{ $t("cerrar") }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- Modal Bajas de lineas de receta -->
        <modal name="modal-downgrades-lines" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header wrapperTitle">
                    <h4 style="margin: 0px">{{ $t('bajasDeProductos') }}</h4>
                </div>

                <!-- Mensaje de error -->
                <div v-if="downgradesError" class="alert alert-danger mt-3 mx-3">
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ downgradesError }}
                </div>

                <!-- Body (solo si hay resultados y no hay error) -->
                <div class="modal-body" v-if="downgradesLines && !downgradesError">
                    <div class="row">
                        <div class="col-md-12">
                            <label>{{ $t("relacionesProcesadas") }}</label>
                            <ul class="list-group">
                                <li v-for="(line, index) in downgradesLines" :key="index"
                                    class="list-group-item d-flex justify-content-between align-items-center"
                                    :class="{ 'list-group-item-success': line.deleted, 'list-group-item-warning': !line.deleted }">
                                    <div>
                                        <strong>#{{ index + 1 }}</strong>
                                        {{ $t("producto") }}: {{ line.idProduct }}
                                        → {{ $t("subproducto") }}: {{ line.idSubproduct }}
                                    </div>
                                    <div>
                                        <small>{{ line.message }}</small>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="closeProductsDowngradesLinesModal" class="btn btn-secondary">
                            <i class="fas fa-times"></i> {{ $t("cerrar") }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- Modal Resumen (Consultar todo) -->
        <modal name="modal-downgrades-summary" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header wrapperTitle">
                    <h4 style="margin: 0px">{{ $t('resumenBajas') }}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <h5>{{ $t('bajaProductos') }}</h5>
                            <p>{{ $t('totalDowngrades') }}: {{ (downgradesProducts && downgradesProducts.totalDowngrades) || 0 }}</p>
                        </div>
                        <div class="col-md-6">
                            <h5>{{ $t('bajaSubproductos') }}</h5>
                            <p>{{ $t('totalDowngrades') }}: {{ (downgradesSubproducts && downgradesSubproducts.totalDowngrades) || 0 }}</p>
                        </div>
                        <div class="col-md-6">
                            <h5>{{ $t('bajaUdMedida') }}</h5>
                            <p>{{ $t('totalDowngrades') }}: {{ unitsTotal }}</p>
                        </div>
                        <div class="col-md-6">
                            <h5>{{ $t('bajaLineaProd') }}</h5>
                            <p>{{ $t('relacionesProcesadas') }}: {{ (downgradesLines && downgradesLines.length) || 0 }}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="$modal.hide('modal-downgrades-summary')" class="btn btn-secondary">
                            <i class="fas fa-times"></i> {{ $t('cerrar') }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- Modal Bajas de formas de pago -->
        <modal name="modal-downgrades-payment-methods" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header wrapperTitle">
                    <h4 style="margin: 0px">{{ $t('paymentMethodDowngrades') }}</h4>
                </div>

                <!-- Body -->
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- Totales -->
                            <div class="form-group" v-if="downgradedPaymentMethods">
                                <label>{{ $t("paymentMethodDowngrades") }}</label>
                                <p>
                                    <strong>{{ $t("totalDowngrades") }}:</strong> {{ downgradedPaymentMethods.total || 0
                                    }}<br>
                                </p>
                            </div> 
                        </div>

                        <!-- Lista de formas de pago dadas de baja -->
                        <div class="col-md-12"
                            v-if="downgradedPaymentMethods && downgradedPaymentMethods.procesados && downgradedPaymentMethods.total > 0">
                            <div class="form-group">
                                <label>{{ $t("downgradedPaymentMethods") }}</label>
                                <ul class="list-group">
                                    <li v-for="(method, index) in downgradedPaymentMethods.procesados"
                                        :key="'DOWN-' + method.id" class="list-group-item">
                                        <strong>#{{ index + 1 }} {{ method.nombre || $t("unknownProduct")
                                        }}</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="closePaymentMethodsDowngradesModal" class="btn btn-secondary">
                            <i class="fas fa-times"></i> {{ $t("cerrar") }}
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>

</template>

<script>
import { Loading } from 'element-ui';
import { Button, Tag, Tabs, TabPane, Collapse, CollapseItem } from 'element-ui';
export default {

    created() {
        this.listBusinesses = this.$route.params.listBusinesses;

        if (!this.listBusinesses) {
            console.warn("listBusinesses no encontrado, redirigiendo a /integraciones...");
            this.shouldRedirect = true;  // Establecemos que se debe redirigir sin mostrar el modal
            //this.$router.replace("/integraciones");

            this.$router.push({ name: "integraciones", params: { redirected: true } });
        } else {
            this.localBusinessId = this.listBusinesses[0].id;
        }

        // this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
        // Promise.all([
        //     // this.getCompanies(),
        //     // this.getDatosBusinessCentral(),
        //     // this.getFormasPagoBusinessCentral(),
        //     this.getSubproductsDowngrades(),
        //     this.getProductsDowngrades(),
        //     this.getProductsDowngradesUnits(),
        //     this.getProductsDowngradesLines(),


        //     // this.getProductsDowngradesLinesUnits(),
        // ])
        //     .then(() => {
        //         this.loadingGeneral.close();
        //     })
        //     .catch((err) => {
        //         console.error("Error al obtener los datos de Business Central:", err);
        //         this.loadingGeneral.close();
        //     });

        // console.log("object businesses:", this.listBusinesses);
    },

    data() {
        return {
            businessCentral: true,
            productosPendientes: [],
            materiasPrimasPendientes: [],
            formasDePagoPendientes: 0,
            listBusinesses: [],
            loading: false,
            loadingAll: false,
            isBatchLoading: false,

            idBusiness: this.$store.getters.idBusiness,
            idCompany: null,
            listCompany: [],
            localBusinessId: 0,

            // Flag para prohibirle entrar en la exportación de ventas
            exportacionEnabled: false,
            downgradesProducts: [],
            downgradesSubproducts: [],
            downgradesUnits: [],
            downgradesLines: [],
            downgradedPaymentMethods: [],
            downgradesError: null,

            show: {
                products: false,
                subproducts: false,
                units: false,
                lines: false,
            },
            loadingInline: {
                products: false,
                subproducts: false,
                units: false,
                lines: false,
                payments: false,
            },
            errorsInline: {
                products: null,
                subproducts: null,
                units: null,
                lines: null,
            },

            // Tabs & acordeón
            activeTab: 'products',
            collapseActive: {
                products: [],
                subproducts: [],
                units: [],
                lines: [],
            },

        };
    },

    computed: {
        unitsTotal() {
            // Normaliza distintas formas posibles de respuesta
            // Puede venir como número directo o como objeto { totalDowngrades }
            if (!this.downgradesUnits) return 0;
            if (typeof this.downgradesUnits === 'number') return this.downgradesUnits;
            if (typeof this.downgradesUnits.totalDowngrades === 'number') return this.downgradesUnits.totalDowngrades;
            if (Array.isArray(this.downgradesUnits.downgrades)) return this.downgradesUnits.downgrades.length;
            return 0;
        },
        isLoadingAny() {
            return (
                this.loadingAll || this.isBatchLoading ||
                this.loadingInline.products ||
                this.loadingInline.subproducts ||
                this.loadingInline.units ||
                this.loadingInline.lines
            );
        }
    },

    components: {
        [Button.name]: Button,
        [Tag.name]: Tag,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
    },

    methods: {

        // Modales movidos al padre
        openProductsDowngradesModal() {
            this.$modal.show("modal-downgrades-products");
        },

        closeProductsDowngradesModal() {
            this.$modal.hide("modal-downgrades-products");
        },

        openSubproductsDowngradesModal() {
            this.$modal.show("modal-downgrades-subproducts");
        },

        closeSubproductsDowngradesModal() {
            this.$modal.hide("modal-downgrades-subproducts");
        },

        openProductsDowngradesUnitsModal() {
            this.$modal.show("modal-downgrades-units");
        },

        closeProductsDowngradesUnitsModal() {
            this.$modal.hide("modal-downgrades-units");
        },

        openProductsDowngradesLinesModal() {
            this.$modal.show("modal-downgrades-lines");
        },

        closeProductsDowngradesLinesModal() {
            this.$modal.hide("modal-downgrades-lines");
        },

        openPaymentMethodsDowngradesModal() {
            this.$modal.show("modal-downgrades-payment-methods");
        },

        closePaymentMethodsDowngradesModal() {
            this.$modal.hide("modal-downgrades-payment-methods");
        },

        onBusinessChange() {
            // this.localFormaPago = "";
            // this.$emit('formaPagoChanged', "");
            // this.$emit('businessChanged', this.localBusinessId);
            // console.log("El nuevo negocio es:", this.localBusinessId);
        },

        // Métodos de los modales movidos al padre
        async getAllDowngrades() {
            this.loadingAll = true;
            this.isBatchLoading = true;
            this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
            try {
                await Promise.all([
                    this.getProductsDowngrades({ openModal: false }),
                    this.getSubproductsDowngrades({ openModal: false }),
                    this.getProductsDowngradesUnits({ openModal: false }),
                    this.getProductsDowngradesLines({ openModal: false }),
                    this.getPaymentMethodsDowngrades({ openModal: false }),
                ]);
                this.$modal.show('modal-downgrades-summary');
                // Asegurar acordeones abiertos donde haya datos
                if (this.downgradesProducts && this.downgradesProducts.downgrades && this.downgradesProducts.downgrades.length) {
                    this.collapseActive.products = ['panel'];
                }
                if (this.downgradesSubproducts && this.downgradesSubproducts.downgrades && this.downgradesSubproducts.downgrades.length) {
                    this.collapseActive.subproducts = ['panel'];
                }
                if (this.downgradedPaymentMethods && this.downgradedPaymentMethods.procesados && this.downgradedPaymentMethods.procesados.length) {
                    this.collapseActive.paymentMethods = ['panel'];
                }
                if (this.unitsTotal) {
                    this.collapseActive.units = ['panel'];
                }
                if (this.downgradesLines && this.downgradesLines.length) {
                    this.collapseActive.lines = ['panel'];
                }
            } catch (e) {
                // errores ya gestionados en cada método
            } finally {
                this.loadingAll = false;
                this.isBatchLoading = false;
                if (this.loadingGeneral) this.loadingGeneral.close();
            }
        },

        getSubproductsDowngrades(options = { openModal: true }) {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            if (!this.isBatchLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('loadingBajaSubproductos') });
            }
            this.loadingInline.subproducts = true;

            let vm = this;
            return this.axios
                .get(this.$store.getters.apiUrl + "subproducts/getDowngrades", config)
                .then((response) => {
                    if (response.data.success && response.data.downgrades.length) {
                        this.downgradesSubproducts = response.data;
                        if (options.openModal) this.openSubproductsDowngradesModal();
                        this.show.subproducts = true;
                        this.collapseActive.subproducts = ['panel'];
                        if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();

                    } else {
                        // Sin bajas en la respuesta: hay que VACIAR la lista. Si no, se
                        // queda en pantalla la de la pasada anterior y el contador sigue
                        // marcando pendientes que ya estan dadas de baja.
                        this.downgradesSubproducts = [];
                        this.show.subproducts = false;
                        this.$notify({
                            type: "warning",
                            message: response.data.message || this.$t('errorDarDeBajaFormasPago')
                        });
                    }
                    if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();
                    this.loadingInline.subproducts = false;
                })
                .catch(function (error) {
                    console.error("Error al obtener las bajas de los productos:", error);
                    if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();
                    vm.loadingInline.subproducts = false;
                });
        },

        getProductsDowngrades(options = { openModal: true }) {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            if (!this.isBatchLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('loadingBajaProductos') });
            }
            this.loadingInline.products = true;

            let vm = this;
            return this.axios
                .get(this.$store.getters.apiUrl + "products/getDowngrades", config)
                .then((response) => {
                    if (response.data.success && response.data.downgrades.length) {
                        this.downgradesProducts = response.data;
                        if (options.openModal) this.openProductsDowngradesModal();
                        this.show.products = true;
                        this.collapseActive.products = ['panel'];
                        if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();

                        // console.log("Baja de productos:", response.data.downgrades);
                        // console.log("Bajas totales:", response.data.totalDowngrades, " | Recetas afectadas:", response.data.totalAffectedRecipes);
                    } else {
                        // Sin bajas en la respuesta: vaciar la lista (ver nota en materias primas).
                        this.downgradesProducts = [];
                        this.show.products = false;
                        this.$notify({
                            type: "warning",
                            message: response.data.message || this.$t('errorDarDeBajaFormasPago')
                        });
                    }
                    if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();
                    this.loadingInline.products = false;

                })
                .catch(function (error) {
                    console.error("Error al obtener las bajas de los productos:", error);
                    if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();
                    vm.loadingInline.products = false;
                });
        },

        getProductsDowngradesUnits(options = { openModal: true }) {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            if (!this.isBatchLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('loadingBajaUdMedida') });
            }
            this.loadingInline.units = true;

            return this.axios
                .get(this.$store.getters.apiUrl + "businesscentral/deleteUnidadMedia", config)
                .then((response) => {
                    // Verifica la propiedad correcta
                    if (response.data.response === true && response.data.result > 0) {
                        this.downgradesUnits = { totalDowngrades: response.data.result };
                        if (options.openModal) this.openProductsDowngradesUnitsModal();
                        this.show.units = true;
                        this.collapseActive.units = ['panel'];
                        if (!this.isBatchLoading && this.loadingGeneral) this.loadingGeneral.close();

                    } else if (response.data.response === true && (response.data.result.length == 0 || response.data.result === 0)){
                        // Sin bajas: vaciar la lista (ver nota en materias primas).
                        this.downgradesUnits = [];
                        this.show.units = false;
                        if (!this.isBatchLoading && this.loadingGeneral) this.loadingGeneral.close();
                        this.$notify({
                            type: "warning",
                            message: response.data.message || this.$t('emptyBajaUdMedida')
                        });

                    }else {
                        this.downgradesUnits = [];
                        this.show.units = false;
                        this.$notify({
                            type: "danger",
                            message: response.data.message || this.$t('errorDarDeBajaFormasPago')
                        });
                        if (!this.isBatchLoading && this.loadingGeneral) this.loadingGeneral.close();

                    }
                    this.loadingInline.units = false;
                })
                .catch((error) => {
                    console.error("Error al obtener las bajas de los productos:", error);
                    if (!this.isBatchLoading && this.loadingGeneral) this.loadingGeneral.close();
                    this.loadingInline.units = false;
                });
        },

        getProductsDowngradesLines(options = { openModal: true }) {
            const config = {
                params: { jwt: this.$store.getters.jwt },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            // console.log("Las downsgrades lines se van a pedir");

            if (!this.isBatchLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('loadingBajaLineaProd') });
            }
            this.loadingInline.lines = true;

            return this.axios
                .get(this.$store.getters.apiUrl + "businesscentral/downRecepiesProducts", config)
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.response === true) {
                            this.downgradesError = null;
                            this.downgradesLines = response.data.results;
                            if (options.openModal) this.openProductsDowngradesLinesModal();
                            this.show.lines = true;
                            this.collapseActive.lines = ['panel'];
                        } else {
                            this.downgradesError = response.data.message || "Ocurrió un error al obtener las bajas.";
                            this.downgradesLines = null;
                            this.show.lines = false;
                            this.$notify({
                                type: "warning",
                                message: response.data.message || this.$t('errorDarDeBajaFormasPago')
                            });
                        }

                        if (!this.isBatchLoading && this.loadingGeneral) this.loadingGeneral.close();
                    }
                    if (!this.isBatchLoading && this.loadingGeneral) this.loadingGeneral.close();
                    this.loadingInline.lines = false;

                })
                .catch((error) => {
                    console.error("Error al obtener las bajas de los productos:", error);
                    this.downgradesError = "Error de conexión con el servidor.";
                    if (options.openModal) this.openProductsDowngradesLinesModal();
                    this.loadingInline.lines = false;
                });
        },

        getPaymentMethodsDowngrades(options = { openModal: true }) {
            const config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: {
                    Authorization: "Bearer " + this.$store.getters.jwt
                }
            };

            if (!this.isBatchLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('loadingBajaFormasPago') });
            }
            this.loadingInline.paymentMethods = true;

            let vm = this;

            return this.axios
                .post(this.$store.getters.apiUrl + "businesscentral/bajaFormasPagoFromBusinessCentral", {}, config)
                .then(response => {
                    if (response.data.success && response.data.procesados.length){
                        this.downgradedPaymentMethods = response.data;
                        if (options.openModal) this.openPaymentMethodsDowngradesModal();
                        this.show.paymentMethods = true;
                        this.collapseActive.products = ['panel'];
                        if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close(); 
                    } else {
                        // Sin bajas: vaciar la lista (ver nota en materias primas).
                        this.downgradedPaymentMethods = [];
                        this.$notify({
                            type: "warning",
                            message: response.data.message || this.$t('errorDarDeBajaFormasPago')
                        });
                    }
                    if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();
                    this.loadingInline.paymentMethods = false;
                })
                .catch(error => {
                    console.error("Error al obtener las bajas de las formas de pago:", error);
                    if (!this.isBatchLoading && vm.loadingGeneral) vm.loadingGeneral.close();
                    vm.loadingInline.paymentMethods = false;
                });
        },

        // bajaFormasPagoBusinessCentral() {
        //     const config = {
        //         params: {
        //             jwt: this.$store.getters.jwt,
        //         },
        //         headers: {
        //             Authorization: "Bearer " + this.$store.getters.jwt
        //         }
        //     };

        //     this.loadingGeneral = Loading.service({ text: this.$t('dandoDeBajaFormasPago') });

        //     this.axios
        //         .post(this.$store.getters.apiUrl + "formaspago/bajaFormasPagoFromBusinessCentral", {}, config)
        //         .then(response => {
        //             this.loadingGeneral.close();
        //             if (response.data.response) {
        //                 this.$notify({
        //                     type: "success",
        //                     message: this.$t('formasPagoDadasDeBaja')
        //                 });

        //                 // Puedes recargar la lista actualizada si quieres
        //                 this.getDatosFromPagoBusinessCentral(false);

        //             } else {
        //                 this.$notify({
        //                     type: "warning",
        //                     message: response.data.message || this.$t('errorDarDeBajaFormasPago')
        //                 });
        //             }
        //         })
        //         .catch(error => {
        //             this.loadingGeneral.close();
        //             // console.error(" > Error en bajaFormasPagoBusinessCentral:", error);
        //             this.$notify({
        //                 type: "danger",
        //                 message: this.$t('errorServidorDarDeBaja')
        //             });
        //         });
        // }

    }

}
</script>


<style scoped>
.card {
    padding: 20px;
    margin-bottom: 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
}

.form-group label {
    font-weight: bold;
}

.card-text p {
    border-radius: 4px;
    background-color: #fff;
    font-weight: bold;

}

/* Para los botones deshabilitados */
button:disabled,
.btn:disabled {
  cursor: not-allowed;
}

/* Para evitar fondo blanco al hover, que no sé por qué pasa eso */
.btn-outline-secondary:disabled,
.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled:hover,
.btn-outline-secondary.disabled:hover {
  background-color: transparent !important;
  color: #6c757d !important;
  border-color: #6c757d !important;
  opacity: 0.65;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/BusinessCentral/Downgrades/DowngradesBusinessCentral.vue